<template>
  <b-card
    title="مدیریت صورتحساب ها"
  >
    <b-row>
      <b-col
        class="table-size"
      >
        <div class="custom-search">
          <b-row>
            <div class="filter-row">
              <b-button
                class="mb-1 ml-1"
                variant="outline-primary"
                @click="addInvoice()"
              >
                افزودن
              </b-button>

              <b-button
                class="mb-1 mr-auto ml-1"
                variant="outline-success"
                @click="refresh()"
              >
                بروزرسانی همه قیمت ها
              </b-button>

              <b-col md="2">
                <b-form-group
                  label="عنوان"
                  label-for="Title"
                >
                  <b-form-input
                    v-model="filterOptions.Title"
                    @keyup.enter="update(1)"
                  />
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group
                  label="دسته بندی"
                  label-for="OrderCategoryId"
                >
                  <z-order-category
                    v-model="filterOptions.OrderCategoryId"
                    :clearable="true"
                  />
                </b-form-group>
              </b-col>
              <b-button
                v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                class="mb-1 mr-1"
                variant="warning"
                @click="update(1)"
              >فیلتر
              </b-button>
            </div>
          </b-row>
        </div>

        <b-table
          bordered
          hover
          striped
          :items="items"
          :fields="fields"
          class="mt-1 mb-2 position-relative"
          responsive
          :busy="loading"
        >
          <template #cell(Id)="data">
            <b-link
              class="font-weight-bold"
            >
              #{{ data.value }}
            </b-link>
          </template>

          <template #cell(TrackingCode)="data">
            {{ data.item.Order.TrackingCode }}
          </template>

          <template #cell(Patient)="data">
            {{ data.item.Order.Patient }}
          </template>

          <template #cell(OrderCategory)="data">
            <b-badge
              variant="success"
            >
              {{ data.item.Order.OrderCategory.Title }}
            </b-badge>
          </template>

          <template #cell(Date)="data">
            {{ data.item.Order.Date | date }}
          </template>

          <template #cell(OrderTooth)="data">
            {{ data.item.Order.OrderTooth.length }} واحد
          </template>

          <template #cell(Price)="data">
            {{ data.value | price }}
          </template>

          <template #cell(TotalPrice)="data">
            {{ (data.item.Price * data.item.Order.OrderTooth.length) | price }}
          </template>

          <template #cell(actions)="data">

            <div
              class="text-nowrap"
            >
              <feather-icon
                :id="`invoice-row-${data.item.Id}-send-icon`"
                icon="RefreshCwIcon"
                size="16"
                @click="refreshItem(data.item.Id)"
              />

              <feather-icon

                icon="TrashIcon"
                size="16"
                class="ml-1 cursor-pointer"
                @click="remove(data.item.Id)"
              />
            </div>
          </template>

          <template #table-busy>
            <div
              class="text-center my-2"
            >
              <b-spinner
                variant="primary"
                class="align-middle"
              />
              <strong class="ml-1">در حال دریافت اطلاعات ...</strong>
            </div>
          </template>

          <template #table-busy>
            <div
              class="text-center my-2"
            >
              <b-spinner
                variant="primary"
                class="align-middle"
              />
              <strong class="ml-1">در حال دریافت اطلاعات ...</strong>
            </div>
          </template>

        </b-table>

        <z-pagination
          :page="filterOptions.Page"
          :total-rows="totalRows"
          :loading="loading"
          @change="update"
        />

      </b-col>

    </b-row>

    <b-modal
      v-if="showInvoiceModal"
      v-model="showInvoiceModal"
      ok-title="افزودن"
      cancel-title="انصراف"
      cancel-variant="outline-secondary"
      centered
      title="افزودن سفارش"
      :no-close-on-backdrop="true"
      size="sm"
      @ok="save"
    >
      <b-row>

        <b-col cols="12">
          <b-form-group
            label="سفارش"
            label-for="ClinicId"
          >
            <z-order
              v-model="addOrderId"
              :invoice-id="filterOptions.InvoiceId"
            />
          </b-form-group>
        </b-col>
      </b-row>
    </b-modal>
  </b-card>
</template>

<script>

import ZClinic from '@/tools/clinic.vue'
import ZOrderCategory from '@/tools/ordercategory.vue'
import ZOrder from '@/tools/order.vue'

export default {
  name: 'InvoiceDetails',
  components: { ZOrder, ZOrderCategory, ZClinic },
  data() {
    return {
      totalRows: 1000 * 1000,
      loading: false,
      filterOptions: {
        Title: null,
        Page: 1,
        OrderCategoryId: null,
      },
      addOrderId: null,
      showInvoiceModal: false,
      fields: [
        {
          key: 'Id',
          label: '#',
          thClass: 'col-width-50',
        },
        {
          key: 'TrackingCode',
          label: 'کد رهگیری',
        },
        {
          key: 'Patient',
          label: 'بیمار',
        },
        {
          key: 'Date',
          label: 'تاریخ',
        },
        {
          key: 'OrderCategory',
          label: 'دسته بندی',
        },
        {
          key: 'OrderTooth',
          label: 'تعداد',
        },
        {
          key: 'Price',
          label: 'مبلغ واحد',
        },
        {
          key: 'TotalPrice',
          label: 'مبلغ کل',
        },
        {
          key: 'actions',
          label: '',
          thClass: 'col-width-50',
        },
      ],
      items: [],
    }
  },
  computed: {},
  created() {
    if (this.$store.state.zirehState.listFilter[this.$options.name]) {
      this.filterOptions = this.$store.state.zirehState.listFilter[this.$options.name]
    }
    this.filterOptions.InvoiceId = Number(this.$route.params.id)
    this.update()
  },
  methods: {
    update(pageNumber) {
      this.loading = true

      this.filterOptions.Page = pageNumber || this.filterOptions.Page

      this.$store.commit('zirehState/setListFilter', { key: this.$options.name, value: this.filterOptions })

      this.$http.post(
        this.$api.invoiceorder.getlist, this.filterOptions,
      )
        .then(res => {
          this.totalRows = res.totalRow
          this.items = res.data
        })
        .finally(() => {
          this.loading = false
        })
    },
    save() {
      this.$http.post(
        this.$api.invoiceorder.add, { OrderId: this.addOrderId, InvoiceId: this.filterOptions.InvoiceId },
      )
        .then(() => {
          this.update()
        })
        .catch(() => {
          this.showInvoiceModal = true
        })
    },
    addInvoice() {
      this.addOrderId = null
      this.showInvoiceModal = true
    },
    remove(id) {
      this.removeRow(this.$api.invoiceorder.remove, 'Id', id)
    },
    refreshItem(id) {
      this.$http.post(
        this.$api.invoiceorder.refresh, { Id: id },
      )
        .then(() => {
          this.update()
        })
        .catch(() => {
        })
    },
    refresh() {
      this.$http.post(
        this.$api.invoice.refresh, { Id: this.filterOptions.InvoiceId },
      )
        .then(() => {
          this.update()
        })
        .catch(() => {
        })
    },
    today() {
      const today = new Date()
      const year = today.getFullYear()
      const month = String(today.getMonth() + 1).padStart(2, '0')
      const day = String(today.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    },
  },
}
</script>
